import * as angular from 'angular';
import { formDirtyChanged } from '../common/events';
import { DirectiveDefinition } from './directiveDefinition';

interface IConfirmOnExitScope extends angular.IScope {
    formCtrl: angular.IFormController;
    wtConfirmOnExit: any;
}

class WtConfirmOnExitController implements angular.IComponentController {
    private _unwatch: (() => void)[] = [];
    private _message = 'There appears to be unsaved changes... Do you want to leave the page?';

    static $inject = ['$scope', '$rootScope', '$window', '$translate'];

    constructor(private _$scope: IConfirmOnExitScope,
        private _$rootScope: angular.IRootScopeService,
        private _$window: angular.IWindowService,
        private _$translate: angular.translate.ITranslateService) {
        this._message = this._$translate.instant(this._message);
    }

    $onInit() {
        this.routeChange = this.routeChange.bind(this);
        this.beforeUnload = this.beforeUnload.bind(this);
        
        this._$window.addEventListener('beforeunload', this.beforeUnload);
        
        if (this._$scope.formCtrl) {
            this.initFormWatch(this);
        } else {
            this._unwatch.push(this._$scope.$watch(() => this._$scope.formCtrl, () => {
                this.initFormWatch(this);
            }));
        }

        this._unwatch.push(this._$scope.$on('$stateChangeStart', this.routeChange));

        this._$scope.$on('$destroy', () => {
            this._$window.removeEventListener('beforeunload', this.beforeUnload);
            this._unwatch.forEach(w => w());
            this._$rootScope.$broadcast(formDirtyChanged, false);
        });
    }

    beforeUnload(e) {
        if (this._$scope.formCtrl !== undefined && this._$scope.formCtrl.$dirty ||
            this._$scope.wtConfirmOnExit !== undefined && this._$scope.wtConfirmOnExit) {
            e.returnValue = this._message;
            return this._message;
        }
        // no return value on purpose
    }

    routeChange(event, newState, newParams, fromState, fromParams) {
        if (this._$scope.formCtrl !== undefined && this._$scope.formCtrl.$dirty ||
            this._$scope.wtConfirmOnExit !== undefined && this._$scope.wtConfirmOnExit) {        
            if (!confirm(this._message)) {
                event.preventDefault();
            }
        }
    }

    initFormWatch(self) {
        if (this._$scope.formCtrl) {
            self._unwatch.push(this._$scope.$watch(() => this._$scope.formCtrl.$dirty, () => {
                self._$rootScope.$broadcast(formDirtyChanged, this._$scope.formCtrl.$dirty);
            }));
        }
    }
} 

export const WtConfirmOnExitDirective: DirectiveDefinition = {
    directiveId: 'wtConfirmOnExit',
    restrict: 'A',
    controller: WtConfirmOnExitController,
    scope: {
        formCtrl: '<',
        wtConfirmOnExit: '<'
    }
};